var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sitemap-control"},[_c('p',{staticClass:"period-notice",attrs:{"title":_vm.$t('observedSitemap.periodNotice')}},[_c('i',{staticClass:"icon icon--info-outline-gray"}),_c('span',[_vm._v(_vm._s(_vm.$t('observedSitemap.periodNotice')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }